import { createApiClient } from "@jod/api-client";
import { getAuthToken } from "./auth-token.ts";
import { apiMode, assertBackendModeReady, env } from "./env.ts";

assertBackendModeReady(apiMode);

/** Shared, type-safe API client bound to the configured base URL + owner token. */
export const api = createApiClient({
  baseUrl: env.apiBaseUrl,
  getAuthToken,
});
